import { useState } from "react";
import StarRating from "./starRating.js";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { useEffect } from "react";
import axios from "axios";
import config from "../confiq/confiq";
const TestimonialsSlider = ({ testimonials, title }) => {
    const [startIndex, setStartIndex] = useState(0);
    // const visibleCount = 3;
    // const isScrollable = testimonials.length > visibleCount;
    const [expanded, setExpanded] = useState({});
    const [testimonialData, setTestimonialData] = useState([]);
    const [visibleCount, setVisibleCount] = useState(3); 
    useEffect(() => {
        axios
            .get(`${config.apiUrl}api/home/testimonials`, {
                headers: config.headers,
            })
            .then((response) => {
                setTestimonialData(response.data.data.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });

            const handleResize = () => {
                if (window.innerWidth <= 640) {
                    setVisibleCount(1); 
                } else if (window.innerWidth <= 1024) {
                    setVisibleCount(2);
                } else {
                    setVisibleCount(3); 
                }
            };
    
            handleResize();
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
    }, []);
    const isScrollable = testimonials.length > visibleCount;
    const quoteIcon = testimonialData.map(test => test.attributes.quoteIcon.data.attributes.url)
    const toggleExpand = (id) => {
        setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
    };
    const nextSlide = () => {
        if (startIndex + visibleCount < testimonials.length) {
            setStartIndex(startIndex + 1);
        }
    };
    const prevSlide = () => {
        if (startIndex > 0) {
            setStartIndex(startIndex - 1);
        }
    };
    return (
        <div className="Partners-network relative flex flex-col items-center">
            <h2 className="text-center text-2xl font-bold">{title}</h2>
            <div className="relative flex items-center justify-center mt-6 w-full max-w-[900px] mx-auto">
                {isScrollable && (
                    <button
                        onClick={prevSlide}
                        className={visibleCount > 1 ? 'mr-4' : 'absolute left-[-10px] z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 disabled:opacity-50'}
                        // className="mr-4"
                        // className="absolute left-0 z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 disabled:opacity-50"
                        // className="absolute left-[-10px] z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 disabled:opacity-50"
                        disabled={startIndex === 0}
                    >
                        <CaretLeft size={20} />
                    </button>
                )}

                <div className="overflow-hidden w-full">
                    <div
                        className="flex transition-transform duration-500 ease-in-out"
                        style={{ transform: `translateX(-${startIndex * (100 / visibleCount)}%)` }}
                    >
                        {testimonials.map((test, index) => {
                            const isExpanded = expanded[test.id] || false;
                            const imageSrc = quoteIcon[index % quoteIcon.length];

                            return (
                                <div
                                    key={test.id}
                                    // className="partner-card w-[260px] h-auto flex-shrink-0 mx-2 my-4 border rounded-lg p-2"
                                    className="partner-card w-full md:w-[260px] flex-shrink-0 mx-2 border rounded-lg flex flex-col"
                                >
                                    <div className="relative p-1">
                                        <img src={imageSrc} alt="quote" className="absolute top-0 right-2 w-6 h-6" />
                                        <p className="font-bold">{test.partner_name}</p>
                                        <p className="text-sm text-gray-600">{test.partner_role}</p>
                                    </div>
                                    <div className="text-sm mt-2 justify-center flex">
                                        {test.rating ? <StarRating rating={test.rating} /> : <div className="h-[30px]"></div>}
                                    </div>
                                    {test.partner_description && (
                                        <div className="text-sm mt-2 text-gray-600">
                                            <p className={`overflow-hidden ${isExpanded ? "" : "line-clamp-6"}`}>
                                                {test.partner_description}
                                            </p>
                                            {test.partner_description.split(" ").length > 25 && (
                                                <button
                                                    className="text-blue-600 text-xs font-semibold cursor-pointer"
                                                    onClick={() => toggleExpand(test.id)}
                                                >
                                                    {isExpanded ? "Read Less" : "Read More"}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>

                {isScrollable && (
                    <button
                        onClick={nextSlide}
                        className={visibleCount > 1 ? 'ml-4' : 'absolute right-[-10px] z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 disabled:opacity-50'}
                        // className="ml-4"
                        // className="absolute right-0 z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 disabled:opacity-50"
                        // className="absolute right-[-10px] z-10 bg-white p-2 rounded-full shadow-md hover:bg-gray-100 disabled:opacity-50"
                        disabled={startIndex + visibleCount >= testimonials.length}
                    >
                        <CaretRight size={20} />
                    </button>
                )}
            </div>
        </div>
    );
};

export default TestimonialsSlider;
